<app-base-dialog sizeClass="size-20" [bottomBarRightTemplate]="bottomBar" [smallGap]="true">
	<div class="content">
		<div class="header">
			<span class="title">Exporteren als</span>
			<span class="subtitle">Selecteer het formaat en de informatie die je wilt opnemen in de export.</span>
		</div>
		<div class="controls">
			<app-single-select-dropdown [opties]="exportTypeOptions" [selectedOptie]="selectedTypeOption()" (onOptieClicked)="type.set($event)">
			</app-single-select-dropdown>
			@if (type() === ExportType.PDF) {
				<div class="control">
					<div class="header">Pagina-indeling</div>
					<app-single-select-dropdown
						[opties]="orientationOptions"
						[selectedOptie]="selectedOrientationOption()"
						(onOptieClicked)="orientation.set($event)"
					>
					</app-single-select-dropdown>
				</div>
			}
		</div>

		@if ([ExportType.AFBEELDING, ExportType.PDF, ExportType.TABEL].includes(type()) && options.customExportItems.length > 0) {
			<div class="export-items">
				<div class="header">Selecteer data ({{ customExportItemCount() }})</div>
				@for (item of options.customExportItems; track $index) {
					<app-checkbox
						[label]="item.label"
						[value]="item.condition()"
						(valueChange)="item.condition.set($event)"
						[enabled]="item.disabled ? !item.disabled(changedOptions()) : true"
						[appTooltip]="getTooltip(item)"
					></app-checkbox>
				}
			</div>
		}

		<div class="show-in-export">
			<div class="header">Tonen in export ({{ aantalSelected() }})</div>
			<app-checkbox label="Paginatitel" [(value)]="showTitle"></app-checkbox>
			<app-checkbox label="Filters" [(value)]="showFilters"></app-checkbox>
			@if ([ExportType.PDF, ExportType.AFBEELDING].includes(type())) {
				<app-checkbox label="Legenda" [(value)]="showLegenda"></app-checkbox>
			}
			<app-checkbox label="Datum" [(value)]="showDatum"></app-checkbox>
		</div>
	</div>
	<ng-template #bottomBar>
		<app-button buttonType="secondary" (clickit)="dialogRef.close()">Annuleren</app-button>
		@if (type() === ExportType.DATA) {
			<app-button (clickit)="openDataExportDialog()">Kolomselectie</app-button>
		} @else {
			<app-button (clickit)="dialogRef.close(changedOptions())"> Exporteren </app-button>
		}
	</ng-template>
</app-base-dialog>
